import React, { useEffect, useState } from 'react'
import { injectIntl } from 'react-intl'
import { Button, TablePagination, TextField } from '@material-ui/core'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Immutable from 'immutable'
import cn from 'classnames'
import Icon from '@material-ui/core/Icon'
import {
  deleteLookupTable,
  fetchLookupTablesData,
  fetchLookupTablesFilters,
  lookupTableAction,
  setTablesListPsfs,
  setSelectedFilters,
} from 'reducers/lookupTables/reducer'
import CircleLoader from 'components/Loading/CircleLoader'
import ConfirmDialog from 'components/common/Popup/ConfirmDialog'
import { REACT_INTL_PROP_TYPE } from 'constants/propTypes'
import withPromise from 'helpers/withPromise'
import { ReactComponent as FilterIcon } from 'assets/img/filter-icon-secondary.svg'
import { ReactComponent as CollapseIcon } from 'assets/img/collapse-arrow-icon.svg'
import { filterArrBySearchQuery } from 'helpers/common'
import {
  FILTER_TYPE_CREATED_BY,
  FILTER_TYPE_DATE_CREATED_FROM,
  FILTER_TYPE_DATE_CREATED_TO,
  FILTER_TYPE_DATE_UPDATED_FROM,
  FILTER_TYPE_DATE_UPDATED_TO,
  FILTER_TYPE_MODIFIED_BY,
  FILTER_TYPE_STATUS,
  LOOKUP_TABLES_FILTERS,
  FILTER_TYPE_DATE_CREATED,
  FILTER_TYPE_DATE_UPDATED,
} from 'constants/lookupTables'
import { saveLookupTablesFilters } from 'reducers/profile/reducer'
import Psfs from 'lib/psfs/Psfs'
import { ENTER_KEY_CODE } from 'helpers/input'
import messages from './translate'
import CreateTableModalForm from './CreateTableModalForm'
import TableItem from './TableItem'
import FiltersDropdown from './common/FiltersDropdown'
import SelectedFiltersDropdown from './common/SelectedFiltersDropdown'
import NoDataScreen from '../ManagementUI/common/NoDataScreen'

// eslint-disable-next-line max-statements
function TableList({
  intl: { formatMessage },
  tablesListPsfs,
  setTablesListPsfs,
  history,
  profile,
  isLoading,
  lookupTablesData,
  fetchLookupTablesData,
  fetchLookupTablesFilters,
  lookupTableAction,
  deleteLookupTable,
  selectedFilters,
  setSelectedFilters,
  filtersList,
  saveLookupTablesFilters,
}) {
  const { lookupTableFilters } = profile.toJS()
  const {
    [FILTER_TYPE_CREATED_BY]: appliedCreatedBy,
    [FILTER_TYPE_MODIFIED_BY]: appliedModifiedBy,
    [FILTER_TYPE_STATUS]: appliedStatus,
    [FILTER_TYPE_DATE_CREATED_FROM]: appliedDateCreatedFrom,
    [FILTER_TYPE_DATE_CREATED_TO]: appliedDateCreatedTo,
    [FILTER_TYPE_DATE_UPDATED_FROM]: appliedDateUpdatedFrom,
    [FILTER_TYPE_DATE_UPDATED_TO]: appliedDateUpdatedTo,
  } = lookupTableFilters
  const { data: lookupTablesList, count } = lookupTablesData.toJS()
  const filtersListData = filtersList.toJS()
  const selectedFiltersData = selectedFilters.toJS()
  const {
    [FILTER_TYPE_CREATED_BY]: createdByListFilter,
    [FILTER_TYPE_MODIFIED_BY]: modifiedByListFilter,
  } = filtersListData
  const [isUpdating, setIsUpdating] = useState(false)
  const [isCreateTableModalOpened, setIsCreateTableModalOpened] = useState(
    false,
  )
  const [tableTitle, setTableTitle] = useState('')
  const [searchFieldValue, setSearchFieldValue] = useState('')
  const [appliedSearchFieldValue, setAppliedSearchFieldValue] = useState('')
  const [tmpCreatedBy, setTmpCreatedBy] = useState([])
  const [tmpModifiedBy, setTmpModifiedBy] = useState([])
  const [tableColumns, setTableColumns] = useState([])
  const [isDialogOpened, setIsDialogOpened] = useState(false)
  const [filtersMenuAnchor, setFiltersMenuAnchor] = useState(null)
  const [createdBySearchQuery, setCreatedBySearchQuery] = useState('')
  const [modifiedBySearchQuery, setModifiedBySearchQuery] = useState('')
  const [page, setPage] = useState(tablesListPsfs._pagination.page - 1)
  const [rowsPerPage, setRowsPerPage] = useState(
    tablesListPsfs._pagination.limit,
  )
  const [
    filteredCreatedByListFilter,
    setFilteredCreatedByListFilter,
  ] = useState(createdByListFilter)
  const [
    filteredModifiedByListFilter,
    setFilteredModifiedByListFilter,
  ] = useState(modifiedByListFilter)
  const [tableContextMenuPosition, setTableContextMenuPosition] = useState({
    top: 0,
    left: 0,
  })
  const [confirmDialogSettings, setConfirmDialogSettings] = useState({
    popupAction: () => {},
    popupTitle: '',
    // eslint-disable-next-line react/jsx-no-useless-fragment
    popupMessage: <></>,
    confirmButtonText: 'delete',
    confirmButtonColor: 'scales-secondary',
  })

  const hasSelectedFilters = !!selectedFiltersData.length

  const updatePsfsQuery = (storeName, psfs) => {
    const isArrayFilter =
      Array.isArray(lookupTableFilters[storeName]) &&
      lookupTableFilters[storeName].length
    if (
      isArrayFilter ||
      (!Array.isArray(lookupTableFilters[storeName]) &&
        lookupTableFilters[storeName])
    ) {
      psfs.addFilter(
        storeName,
        lookupTableFilters[storeName],
        isArrayFilter ? 'in' : '',
      )
    } else {
      psfs.clearFilter(storeName)
    }
  }

  const updateDateRangePsfsQuery = (storeName, dateFrom, dateTo, psfs) => {
    if (lookupTableFilters[dateFrom] && lookupTableFilters[dateTo]) {
      psfs.addFilter(storeName, [
        lookupTableFilters[dateFrom],
        lookupTableFilters[dateTo],
      ])
    } else {
      psfs.clearFilter(storeName)
    }
  }

  const updateFilters = () => {
    const { path } = tablesListPsfs
    const psfs = new Psfs(path)

    updatePsfsQuery(FILTER_TYPE_CREATED_BY, psfs)
    updatePsfsQuery(FILTER_TYPE_MODIFIED_BY, psfs)
    updatePsfsQuery(FILTER_TYPE_STATUS, psfs)
    updateDateRangePsfsQuery(
      FILTER_TYPE_DATE_CREATED,
      FILTER_TYPE_DATE_CREATED_FROM,
      FILTER_TYPE_DATE_CREATED_TO,
      psfs,
    )
    updateDateRangePsfsQuery(
      FILTER_TYPE_DATE_UPDATED,
      FILTER_TYPE_DATE_UPDATED_FROM,
      FILTER_TYPE_DATE_UPDATED_TO,
      psfs,
    )

    setTablesListPsfs(psfs)
  }

  useEffect(() => {
    fetchLookupTablesFilters()
    if (tablesListPsfs && tablesListPsfs?.searchObj?.value) {
      setSearchFieldValue(tablesListPsfs?.searchObj?.value)
      setAppliedSearchFieldValue(tablesListPsfs?.searchObj?.value)
    }
  }, [])

  useEffect(() => {
    const filteredCreatedBy = filterArrBySearchQuery(
      createdByListFilter,
      createdBySearchQuery,
    )

    setFilteredCreatedByListFilter(filteredCreatedBy)
  }, [createdBySearchQuery])

  useEffect(() => {
    setFilteredCreatedByListFilter(createdByListFilter)
  }, [createdByListFilter])

  useEffect(() => {
    const filteredModifiedBy = filterArrBySearchQuery(
      modifiedByListFilter,
      modifiedBySearchQuery,
    )

    setFilteredModifiedByListFilter(filteredModifiedBy)
  }, [modifiedBySearchQuery])

  useEffect(() => {
    setFilteredModifiedByListFilter(modifiedByListFilter)
  }, [modifiedByListFilter])

  // eslint-disable-next-line max-statements
  useEffect(() => {
    const filteredAppliedCreatedBy = createdByListFilter.filter(({ id }) =>
      appliedCreatedBy.find(user => user === id),
    )
    const filteredAppliedModifiedBy = modifiedByListFilter.filter(({ id }) =>
      appliedModifiedBy.find(user => user === id),
    )
    const filters = []

    if (filteredAppliedCreatedBy.length) {
      const filter = LOOKUP_TABLES_FILTERS.find(
        ({ value }) => value === FILTER_TYPE_CREATED_BY,
      )
      const isSelected = selectedFiltersData.find(
        ({ value }) => value === FILTER_TYPE_CREATED_BY,
      )

      if (!isSelected) {
        filters.push(filter)
      }
    }

    if (filteredAppliedModifiedBy.length) {
      const filter = LOOKUP_TABLES_FILTERS.find(
        ({ value }) => value === FILTER_TYPE_MODIFIED_BY,
      )
      const isSelected = selectedFiltersData.find(
        ({ value }) => value === FILTER_TYPE_MODIFIED_BY,
      )

      if (!isSelected) {
        filters.push(filter)
      }
    }

    if (appliedStatus) {
      const filter = LOOKUP_TABLES_FILTERS.find(
        ({ value }) => value === FILTER_TYPE_STATUS,
      )
      const isSelected = selectedFiltersData.find(
        ({ value }) => value === FILTER_TYPE_STATUS,
      )

      if (!isSelected) {
        filters.push(filter)
      }
    }

    if (appliedDateCreatedFrom && appliedDateCreatedTo) {
      const filter = LOOKUP_TABLES_FILTERS.find(
        ({ value }) => value === FILTER_TYPE_DATE_CREATED,
      )
      const isSelected = selectedFiltersData.find(
        ({ value }) => value === FILTER_TYPE_DATE_CREATED,
      )

      if (!isSelected) {
        filters.push(filter)
      }
    }

    if (appliedDateUpdatedFrom && appliedDateUpdatedTo) {
      const filter = LOOKUP_TABLES_FILTERS.find(
        ({ value }) => value === FILTER_TYPE_DATE_UPDATED,
      )
      const isSelected = selectedFiltersData.find(
        ({ value }) => value === FILTER_TYPE_DATE_UPDATED,
      )

      if (!isSelected) {
        filters.push(filter)
      }
    }

    if (filters.length) {
      setSelectedFilters([...selectedFiltersData, ...filters])
    }

    setTmpCreatedBy(filteredAppliedCreatedBy)
    setTmpModifiedBy(filteredAppliedModifiedBy)

    updateFilters()
  }, [
    appliedDateCreatedFrom,
    appliedDateCreatedTo,
    appliedDateUpdatedFrom,
    appliedDateUpdatedTo,
    appliedStatus,
    JSON.stringify(filtersListData),
    JSON.stringify(appliedCreatedBy),
    JSON.stringify(appliedModifiedBy),
  ])

  useEffect(() => {
    fetchLookupTablesData({
      psfs: tablesListPsfs,
    })

    setIsUpdating(false)
  }, [JSON.stringify(tablesListPsfs)])

  useEffect(() => {
    const { path } = tablesListPsfs
    const psfs = new Psfs(path)

    psfs.addSearch(appliedSearchFieldValue)

    setTablesListPsfs(psfs)
  }, [appliedSearchFieldValue])

  useEffect(() => {
    const { path } = tablesListPsfs
    const psfs = new Psfs(path)

    psfs.addPagination(page + 1, rowsPerPage)

    setTablesListPsfs(psfs)
  }, [page, rowsPerPage])

  const clearSelectedFilters = () => {
    const saveFiltersPayload = {
      lookup_table_filters: {
        [FILTER_TYPE_CREATED_BY]: [],
        [FILTER_TYPE_MODIFIED_BY]: [],
        [FILTER_TYPE_STATUS]: null,
        [FILTER_TYPE_DATE_CREATED_FROM]: null,
        [FILTER_TYPE_DATE_CREATED_TO]: null,
        [FILTER_TYPE_DATE_UPDATED_FROM]: null,
        [FILTER_TYPE_DATE_UPDATED_TO]: null,
      },
    }

    setIsUpdating(true)
    setSelectedFilters([])
    saveLookupTablesFilters(saveFiltersPayload)
  }

  const onClearFilter = () => {
    const saveFiltersPayload = {
      lookup_table_filters: {
        [FILTER_TYPE_CREATED_BY]: [],
        [FILTER_TYPE_MODIFIED_BY]: [],
        [FILTER_TYPE_STATUS]: null,
        [FILTER_TYPE_DATE_CREATED_FROM]: null,
        [FILTER_TYPE_DATE_CREATED_TO]: null,
        [FILTER_TYPE_DATE_UPDATED_FROM]: null,
        [FILTER_TYPE_DATE_UPDATED_TO]: null,
      },
    }

    setIsUpdating(true)
    setTmpCreatedBy([])
    setTmpModifiedBy([])
    setSelectedFilters([])
    saveLookupTablesFilters(saveFiltersPayload)
  }

  const onResetFilters = event => {
    setTmpCreatedBy([])
    setTmpModifiedBy([])
    setCreatedBySearchQuery('')
    setModifiedBySearchQuery('')
    clearSelectedFilters()
    event.stopPropagation()
  }

  const onOpenCreateTableModal = () => {
    setIsCreateTableModalOpened(true)
  }

  const onCloseCreateTableModal = (resetForm = false) => {
    if (resetForm) {
      setTableTitle('')
      setTableColumns([])
    }

    setIsCreateTableModalOpened(false)
  }

  const onCloseDialog = () => {
    setIsDialogOpened(false)
  }

  const renderCreateTableButton = () => (
    <Button
      className="lookup-tables-button primary"
      onClick={onOpenCreateTableModal}>
      + {formatMessage(messages.newTable)}
    </Button>
  )

  const onActionSuccess = successAction => {
    setIsDialogOpened(false)
    successAction()
  }

  const onConfirmTableAction = (
    tableId,
    actionName,
    successAction,
    successMessage,
    errorMessage,
  ) => {
    withPromise(lookupTableAction, {
      id: tableId,
      action: actionName,
      successMessage,
      errorMessage,
    }).then(response => {
      if (!response.error) {
        onActionSuccess(successAction)
      }
    })
  }

  const onConfirmDeleteTable = (
    tableId,
    successAction,
    successMessage,
    errorMessage,
  ) => {
    withPromise(deleteLookupTable, {
      id: tableId,
      successMessage,
      errorMessage,
    }).then(response => {
      if (!response.error) {
        onActionSuccess(successAction)
      }
    })
  }

  const handleSearchField = () => {
    if (searchFieldValue !== appliedSearchFieldValue) {
      setPage(0)
      setAppliedSearchFieldValue(searchFieldValue)
    }
  }

  const renderNoTableScreen = () => {
    const noFiltersFilled =
      !tablesListPsfs._filters.getCriteria().length && !appliedSearchFieldValue

    return (
      <NoDataScreen
        onClearFilter={onClearFilter}
        isUpdating={isUpdating}
        specialNoResultScreen={
          noFiltersFilled ? (
            <div className="lookup-tables-no-result">
              <div className="title">
                {formatMessage(messages.noTablesMessage)}
              </div>
              <div className="text">
                {formatMessage(messages.createTableMessage)}
              </div>
              {renderCreateTableButton()}
            </div>
          ) : null
        }
      />
    )
  }

  const applyFilter = lookup_table_filters => {
    const saveFiltersPayload = {
      lookup_table_filters,
    }

    setPage(0)
    setIsUpdating(true)
    saveLookupTablesFilters(saveFiltersPayload)
  }

  const onClearSearch = () => {
    setSearchFieldValue('')
    setAppliedSearchFieldValue('')
  }

  const renderLookupTablesList = () => (
    <div className="tables-list-section">
      <div className="tables-list-header">
        <div className="lookup-tables-col id-col">ID</div>
        <div className="lookup-tables-col title-col">
          {formatMessage(messages.title)}
        </div>
        <div className="lookup-tables-col status-col">
          {formatMessage(messages.status)}
        </div>
        <div className="lookup-tables-col created-by-col">
          {formatMessage(messages.createdBy)}
        </div>
        <div className="lookup-tables-col date-col">
          {formatMessage(messages.dateCreated)}
        </div>
        <div className="lookup-tables-col created-by-col">
          {formatMessage(messages.modifiedBy)}
        </div>
        <div className="lookup-tables-col date-col">
          {formatMessage(messages.dateUpdated)}
        </div>
        <div className="lookup-tables-col configure-col" />
      </div>
      <div className="tables-list">
        {lookupTablesList.map(table => (
          <TableItem
            key={table.id}
            setTableContextMenuPosition={setTableContextMenuPosition}
            setConfirmDialogSettings={setConfirmDialogSettings}
            setIsDialogOpened={setIsDialogOpened}
            history={history}
            onConfirmTableAction={onConfirmTableAction}
            onConfirmDeleteTable={onConfirmDeleteTable}
            {...table}
          />
        ))}
      </div>
      <TablePagination
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[10, 20, 50, 100]}
        onChangePage={(event, nextPage) => {
          setPage(nextPage)
        }}
        onChangeRowsPerPage={(event, { props: { value } }) => {
          setPage(0)
          setRowsPerPage(value)
        }}
        component="div"
        className="table-pagination"
        labelRowsPerPage={formatMessage({ id: 'rows_per_page' })}
        backIconButtonProps={{
          'aria-label': formatMessage({ id: 'previous_page' }),
        }}
        nextIconButtonProps={{
          'aria-label': formatMessage({ id: 'next_page' }),
        }}
      />
    </div>
  )

  return (
    <>
      <div className="lookup-tables-header">
        <h2 className="lookup-tables-title">
          {formatMessage(messages.lookupTablesAppName)}
        </h2>
      </div>
      <div className="filter-bar-section">
        <div className="filter-block">
          <Button
            type="button"
            className={cn('management-ui-button filters-button', {
              active: hasSelectedFilters,
            })}
            onClick={({ currentTarget }) => {
              setFiltersMenuAnchor(currentTarget)
            }}>
            <FilterIcon className="filters-icon" />
            {selectedFiltersData.length || formatMessage(messages.filters)}
            {hasSelectedFilters ? (
              <span
                onClick={event => {
                  onResetFilters(event)
                }}
                className="reset-other-filters"
              />
            ) : (
              <CollapseIcon className="collapse-icon" />
            )}
          </Button>
          {hasSelectedFilters ? (
            <SelectedFiltersDropdown
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              filtersMenuAnchor={filtersMenuAnchor}
              setFiltersMenuAnchor={setFiltersMenuAnchor}
              createdBySearchQuery={createdBySearchQuery}
              setCreatedBySearchQuery={setCreatedBySearchQuery}
              modifiedBySearchQuery={modifiedBySearchQuery}
              setModifiedBySearchQuery={setModifiedBySearchQuery}
              tmpCreatedBy={tmpCreatedBy}
              tmpModifiedBy={tmpModifiedBy}
              setTmpCreatedBy={setTmpCreatedBy}
              setTmpModifiedBy={setTmpModifiedBy}
              filteredCreatedByListFilter={filteredCreatedByListFilter}
              filteredModifiedByListFilter={filteredModifiedByListFilter}
              applyFilter={applyFilter}
              setIsUpdating={setIsUpdating}
            />
          ) : (
            <FiltersDropdown
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              anchorEl={filtersMenuAnchor}
              applyFilter={applyFilter}
              setAnchorEl={setFiltersMenuAnchor}
            />
          )}
          <div className="search-block">
            <Icon className="search-block-icon search">search</Icon>
            <TextField
              value={searchFieldValue}
              placeholder={formatMessage(messages.search)}
              className="search-input wide"
              onChange={({ currentTarget: { value } }) => {
                setSearchFieldValue(value)
              }}
              onBlur={() => {
                handleSearchField()
              }}
              onKeyDown={e => {
                if (e.keyCode === ENTER_KEY_CODE) {
                  handleSearchField()
                }
              }}
            />
            {!!searchFieldValue && (
              <Icon className="search-block-icon clear" onClick={onClearSearch}>
                clear
              </Icon>
            )}
          </div>
        </div>
        {renderCreateTableButton()}
      </div>
      {lookupTablesList.length
        ? renderLookupTablesList()
        : renderNoTableScreen()}
      <CreateTableModalForm
        isCreateTableModalOpened={isCreateTableModalOpened}
        onCloseCreateTableModal={onCloseCreateTableModal}
        tableTitle={tableTitle}
        setTableTitle={setTableTitle}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
      />
      <ConfirmDialog
        open={isDialogOpened}
        cancel={{
          color: 'default',
          variant: 'outlined',
          customText: formatMessage(messages.cancel),
        }}
        confirm={{
          color: confirmDialogSettings.confirmButtonColor,
          customText: formatMessage(
            messages[confirmDialogSettings.confirmButtonText],
          ),
        }}
        onClose={onCloseDialog}
        onConfirmAction={confirmDialogSettings.popupAction}
        className="dialog-primary-custom"
        title={confirmDialogSettings.popupTitle}
        message={confirmDialogSettings.popupMessage}
      />
      <div
        className="table-context-menu-anchor-el"
        style={tableContextMenuPosition}
      />
      <CircleLoader loading={isLoading} />
    </>
  )
}

TableList.propTypes = {
  intl: REACT_INTL_PROP_TYPE.isRequired,
  isLoading: PropTypes.bool.isRequired,
  lookupTablesData: PropTypes.instanceOf(Immutable.Map).isRequired,
  fetchLookupTablesData: PropTypes.func.isRequired,
}

export default connect(
  state => ({
    tablesListPsfs: state.getIn(['lookupTables', 'tablesListPsfs']),
    isLoading: state.getIn(['lookupTables', 'isLoading']),
    lookupTablesData: state.getIn(['lookupTables', 'lookupTablesData']),
    selectedFilters: state.getIn(['lookupTables', 'selectedFilters']),
    filtersList: state.getIn(['lookupTables', 'filtersList']),
    profile: state.getIn(['profile', 'profile']),
  }),
  {
    setTablesListPsfs,
    fetchLookupTablesData,
    fetchLookupTablesFilters,
    lookupTableAction,
    deleteLookupTable,
    setSelectedFilters,
    saveLookupTablesFilters,
  },
)(injectIntl(TableList))
